import { render, staticRenderFns } from "./BankTransferTabV1.vue?vue&type=template&id=44fcf372&scoped=true&"
import script from "./BankTransferTabV1.vue?vue&type=script&lang=js&"
export * from "./BankTransferTabV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcf372",
  null
  
)

export default component.exports